import { reporteApi } from '@/api'
import { ReporteComboInterface } from '@/models'

const useReporteEndpoint = () => {
  const initCU = async () => {
    try {
      const { data } = await reporteApi.get<ReporteComboInterface>(`initCU`)

      return { ok: true, response: data }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  return {
    initCU,
  }
}

export default useReporteEndpoint
